import { CommonModule } from '@angular/common';
import {  NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { RouterModule } from '@angular/router';

import { QuillModule } from 'ngx-quill';

import { IonicModule } from '@ionic/angular';

import { AddDiscountComponent } from './add-discount/add-discount.component';
import { AddInventoryComponent } from './add-inventory/add-inventory.component';
// import { CachedImageComponent } from './cached-image/cached-image.component';
import { CategoryBarComponent } from './category-bar/category-bar.component';
import { CategorylistComponent } from './categorylist/categorylist.component';
import { CusAddAddressComponent } from './cus-add-address/cus-add-address.component';
import { CusAddressComponent } from './cus-address/cus-address.component';
import { CusOrdersComponent } from './cus-orders/cus-orders.component';
import { CusRewardPointsComponent } from './cus-reward-points/cus-reward-points.component';
import { CusWalletComponent } from './cus-wallet/cus-wallet.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { CustomerssComponent } from './customerss/customerss.component';
import { ExpandableComponent } from './expandable/expandable.component';
import { FormControlComponent } from './form-control/form-control.component';
import { InventoryManagementComponent } from './inventory-management/inventory-management.component';
import { LogInComponent } from './log-in/log-in.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { OrderStatusUpdateComponent } from './order-status-update/order-status-update.component';
import { OrderssComponent } from './orderss/orderss.component';
import { PosCategoryComponent } from './pos-category/pos-category.component';
// import { PosOrdersComponent } from './pos-orders/pos-orders.component';
import { PosProductsComponent } from './pos-products/pos-products.component';
import { AttributesAddComponent } from './products-mgmt/attributes-add/attributes-add.component';
import { AttributesEditComponent } from './products-mgmt/attributes-edit/attributes-edit.component';
import { CategorySelectionComponent } from './products-mgmt/category-selection/category-selection.component';
import { DynamicFormComponent } from './products-mgmt/dynamic-form/dynamic-form.component';
import { ImageAddComponent } from './products-mgmt/image-add/image-add.component';
import { VariantsEditComponent } from './products-mgmt/variants-edit/variants-edit.component';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';
// import { RegisterProgressComponent } from './register-progress/register-progress.component';
import { ReportsComponent } from './reports/reports.component';
import { SearchProductsComponent } from './search-products/search-products.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { WebHeaderComponent } from './web-header/web-header.component';
// import { WebformComponent } from './webform/webform.component';
import {DiscountListComponent} from './discount-list/discount-list.component';
// import {
//   ReversePipe,
//   YourCartComponent,
// } from './your-cart/your-cart.component';
// import { SubscriptionComponent } from './subscription/subscription.component';
import { ReturnResonsComponent } from './return-resons/return-resons.component';
import { MakeReturnComponent } from './make-return/make-return.component';
import { PrinterSettingsComponent } from './printer-settings/printer-settings.component';
import { MapsComponent } from './maps/maps.component';

import { AdminCategoryListComponent } from './vendor/admin-category-list/admin-category-list.component';
import { ViewCategoryComponent } from './vendor/view-category/view-category.component';
import { ViewProductComponent } from './vendor/view-product/view-product.component';
import { AdminProductListComponent } from './vendor/admin-product-list/admin-product-list.component';
import { AttributesAddImgComponent } from './products-mgmt/attributes-add-img/attributes-add-img.component';
import { WizardFormsComponent } from './forms/wizard-forms/wizard-forms.component';
import { TabsButtonComponent } from './tabs-button/tabs-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CategoriesComponent } from './add-inventory-management/categories/categories.component';
import { InventoryCheckoutComponent } from './add-inventory-management/inventory-checkout/inventory-checkout.component';
import { ProductListComponent } from './add-inventory-management/product-list/product-list.component';
import { WarehouseListComponent } from './add-inventory-management/warehouse-list/warehouse-list.component';
import { NoRecordFoundComponent } from './no-record-found/no-record-found.component';
import { VariantMappingComponent } from './add-inventory-management/variant-mapping/variant-mapping.component';
import { ProductsComponent } from './add-pricing-management/products/products.component';
import { CategoryListComponent } from './add-pricing-management/category-list/category-list.component';
import { AddPriceComponent } from './add-pricing-management/add-price/add-price.component';
import { PriceDetailComponent } from './add-pricing-management/price-detail/price-detail.component';
import { OtpLoginComponent } from './auth/otp-login/otp-login.component';
import { ListViewComponent } from './list-view/list-view.component';
import { ForgetComponent } from './forget/forget.component';
// import {ReversePipe} from './'
import {
  FivGalleryModule,
  FivSpinnerModule,
  FivCenterModule
} from '@fivethree/core';
import { SellerFormReviewComponent } from './seller-form-review/seller-form-review.component';
import { AttributesListOptionsComponent } from './products-mgmt/attributes-list-options/attributes-list-options.component';
import { ProfileComponent } from './profile/profile.component';

@NgModule({
  declarations: [
    // CachedImageComponent,
    // YourCartComponent,
    CategorylistComponent,
    CategoryBarComponent,
    // RegisterProgressComponent,
    ProfileMenuComponent,
    PosProductsComponent,
    // PosOrdersComponent,
    PosCategoryComponent,
    OrderDetailComponent,
    LogInComponent,
    InventoryManagementComponent,
    FormControlComponent,
    ExpandableComponent,
    CustomerDetailsComponent,
    CusWalletComponent,
    CusRewardPointsComponent,
    CusOrdersComponent,
    CusAddressComponent,
    AddInventoryComponent,
    SearchProductsComponent,AddDiscountComponent,
    // ReversePipe,
    OrderssComponent,
    CategorySelectionComponent,
    ImageAddComponent,
    AttributesAddComponent,
    AttributesEditComponent,
    VariantsEditComponent,
    DynamicFormComponent,
    ReportsComponent,
    WebHeaderComponent,
    CustomerssComponent,
    OrderStatusUpdateComponent,
    SideMenuComponent,
    CusAddAddressComponent,
    // SubscriptionComponent,
    ReturnResonsComponent,
    MakeReturnComponent,
    PrinterSettingsComponent,
    MapsComponent,DiscountListComponent,
    AdminCategoryListComponent,
    ViewCategoryComponent,
    ViewProductComponent,
    AdminProductListComponent,
    AttributesAddImgComponent,
    WizardFormsComponent,
    TabsButtonComponent,
    CategoriesComponent,
    InventoryCheckoutComponent,
    ProductListComponent,
    WarehouseListComponent,
    NoRecordFoundComponent,
    VariantMappingComponent,
    ProductsComponent,
    PriceDetailComponent,
    CategoryListComponent,
    AddPriceComponent,
    OtpLoginComponent,
    ListViewComponent,
    SellerFormReviewComponent,
    ForgetComponent,
    AttributesListOptionsComponent,
    ProfileComponent
    // WebformComponent
  ],
  imports: [
    // IonicModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    FivGalleryModule,FivSpinnerModule,FivCenterModule,
    QuillModule.forRoot(),
    NgSelectModule
  ],
  exports:[
    // CachedImageComponent,
    // YourCartComponent,
    CategorylistComponent,
    CategoryBarComponent,
    // RegisterProgressComponent,
    ProfileMenuComponent,
    PosProductsComponent,
    // PosOrdersComponent,
    PosCategoryComponent,
    OrderDetailComponent,
    LogInComponent,
    InventoryManagementComponent,
    FormControlComponent,
    ExpandableComponent,
    CustomerDetailsComponent,
    CusWalletComponent,
    CusRewardPointsComponent,
    CusOrdersComponent,
    CusAddressComponent,
    AddInventoryComponent,
    SearchProductsComponent,
    AddDiscountComponent,
    OrderssComponent,
    CategorySelectionComponent,
    ImageAddComponent,
    AttributesAddComponent,
    AttributesEditComponent,
    VariantsEditComponent,
    DynamicFormComponent,
    ReportsComponent,
    WebHeaderComponent,
    CustomerssComponent,
    OrderStatusUpdateComponent,
    SideMenuComponent,
    CusAddAddressComponent,
    // SubscriptionComponent,
    MakeReturnComponent,
    PrinterSettingsComponent,
    MapsComponent,DiscountListComponent,
    AdminCategoryListComponent,
    ViewCategoryComponent,
    ViewProductComponent,
    AdminProductListComponent,
    AttributesAddImgComponent,
    WizardFormsComponent,
    TabsButtonComponent,
    CategoriesComponent,
    InventoryCheckoutComponent,
    ProductListComponent,
    WarehouseListComponent,
    NoRecordFoundComponent,
    VariantMappingComponent,
    ProductsComponent,
    PriceDetailComponent,
    CategoryListComponent,
    OtpLoginComponent,
    AddPriceComponent,
    ListViewComponent,
    ForgetComponent,
    AttributesListOptionsComponent,
    ProfileComponent
    // WebformComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA]
})


export class SharedComponentsModule { }
 